// Header.tsx
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { ConditionalRendering } from '../../../../components/common/conditional-rendering';

interface HeaderProps {
    years: string[];
    selectedYear: string;
    setSelectedYear: (year: string) => void;
}

const StyledHeaderContainer = styled.div`
    margin-bottom: 2rem;
`;

const StyledTitle = styled.h4`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const StyledDropdown = styled.select`
    width: auto;
`;

const StyledCoverageYearLabel = styled.span`
    margin-right: 10px;
`;

const StyledDateField = styled.div`
    display: flex;
    flex-direction: row-reverse;
    align-items: baseline;
`;

const Header: React.FC<HeaderProps> = ({ years, selectedYear, setSelectedYear }) => {
    const intl = useIntl();

    return (
        <StyledHeaderContainer>
            <StyledTitle className="header">
                {intl.formatMessage({ id: 'common.enrollment' })}
                <StyledDateField>
                    <ConditionalRendering isTrue={years.length > 0}>
                        <StyledDateField
                            className="dropdown coverage-year coverage-year_dropdown pull-right"
                            style={{ marginTop: '-5px' }}
                        >
                            <StyledDropdown
                                className="input-small"
                                value={selectedYear}
                                onChange={e => setSelectedYear(e.target.value)}
                            >
                                {years.map(year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </StyledDropdown>
                        </StyledDateField>
                        <StyledCoverageYearLabel className="pull-right">
                            {intl.formatMessage({ id: 'common.coverage_year' })}&nbsp;
                        </StyledCoverageYearLabel>
                    </ConditionalRendering>
                </StyledDateField>
            </StyledTitle>
        </StyledHeaderContainer>
    );
};

export default Header;
